export default "__VITE_ASSET__CTvLz5IH__"